import {EditOutlined, LoadingOutlined, WarningOutlined} from "@ant-design/icons";
import {Button, Flex, Space, Spin, Typography} from "antd";

import Footer from "../../components/footer";
import Header from "./Header";
import React, {useEffect, useState} from "react";
import ServiceApi from "../../apis/ServiceApi";
import SignApi from "../../apis/SignApi";
import {getParamFromUrl, showNotification} from "../../common";
import Password from "antd/es/input/Password";
import config from "../../apis/EndpointConfig";

const PublicCapBu = () => {


  const [loadingPage, setLoadingPage] = useState(true);

  const [statusPage, setStatusPage] = useState(0);//0: chưa cài plugin hoặc chưa run plugin,1: chưa căm token,2: hiện thì giao diện check,3: không thuộc câp bù
  const [pin, setPin] = useState(false);
  useEffect( () => {

    async function fetchData() {
      // You can await here
      //const response = await ServiceApi.createTokenauthen('FF1241141918','54010165959528da2a43d719efe6f60e');
      //const responselocal = await SignApi.getTokenInfo('1234567');
      // ...
      //console.log(responselocal.data);
    //  console.log(response);
      let iscapbu = getParamFromUrl("iscapbu");
      if(iscapbu === undefined || iscapbu === null) {
        iscapbu = 'true';
      }
      checkSetupPlugin(iscapbu);
    //  setLoadingPage(false);
    }
    fetchData().then(r => {

    });
  }, []);

  const checkSetupPlugin = async (iscapbu) => {
    setLoadingPage(true);
    try {
      debugger;
      if(iscapbu === 'false'){
        setStatusPage(3);
        return true;
      }
      const resCheckVersion = await SignApi.checkVersion();
      if (
          resCheckVersion &&
          resCheckVersion.status === 200 &&
          resCheckVersion.data
      ) {
        setStatusPage(2);
        return true;
      } else {
        showNotification(
            "error",
            "Vui lòng cài đặt hoặc bật phần mềm ký",
            "Thông báo"
        );
        setStatusPage(0);
        return false;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
      return false;
    } finally {
      setLoadingPage(false);
    }
  };
  const handleTiepTuc = async () => {

    const responselocal = await SignApi.getTokenInfo(pin);
    console.log(responselocal.data);
    if(responselocal.data.Code !== 100){
      showNotification("error", responselocal.data.Message, 'Thông báo');
    }else{
      let tokenSn = responselocal.data.SerialNumber;
      if(responselocal.data.Certificates.length > 0){
        let certSerinumber = responselocal.data.Certificates[0].Serial;
        console.log("tokenSn:"+tokenSn);
        console.log("certSerinumber"+ certSerinumber);
        const responseEncript = await ServiceApi.createTokenauthen(tokenSn,certSerinumber);
        console.log(responseEncript);
        if(responseEncript.data.status !== 200){
          showNotification("error", responseEncript.data.message, 'Thông báo');
        }else{

          let urltkgw = `${config.BACKEND_HOST_GATEWAY_SERVICE_PATH}/tokengw/open?data=${responseEncript.data.data}&ispublic=true`;
          console.log("urltkgw:", urltkgw);
          window.location.href= urltkgw;
        }
      }else{
        showNotification("error", "Không tìm thấy chứng thư số trong token", 'Thông báo');
      }
    }
  };
  const renderPage = () => {
    if(statusPage === 0){
      return (
          <div style={{ width: "100%" }}>
            <Typography.Title level={3} strong mark type="danger" className="text-center">
              <Space>
                <WarningOutlined />
                THÔNG BÁO

              </Space>
            </Typography.Title>
            <div>
              <div style={{width:"100%",fontSize:"17px"}} className="text-center"> PHẦN MỀM <b><i>FASTCA PLUGIN</i></b> TRÊN MÁY TÍNH CỦA BẠN <i style={{color:"red",textDecoration:"underline"}}>CHƯA ĐƯỢC CÀI ĐẶT</i> HOẶC {" "}
                <i style={{textDecoration:"underline",color:"red"}}>CHƯA KHỞI ĐỘNG.</i></div>
             <br/>
              <div style={{fontSize:"17px"}}>QUÝ KHÁCH VUI LÒNG:</div>

              <ol style={{fontSize:"17px"}}>
                <li>CÀI ĐẶT FASTCA PLUGIN <a href="https://gen.fastca.vn/tao-lap-chung-thu/downloadPlugin" download style={{textDecoration:"underline",color:"red"}}>
                  <b>TẠI ĐÂY</b>
                </a> HOẶC KHỞI ĐỘNG LẠI <b>FASTCA PLUGIN</b></li>
                <li>THỰC HIỆN NHẬP LẠI MÃ PIN VÀ KIỂM TRA CHỨNG THƯ SỐ CẤP BÙ FASTCA.</li>
              </ol>


            </div>
            <div style={{ width: "100%",fontSize:"17px" }} className="text-center">
              CHÚC QUÝ KHÁCH HÀNG THỰC HIỆN THÀNH CÔNG.
            </div>
          </div>);
    }else if(statusPage === 2){
      return (
          <div style={{width: "100%"}}>
            <Typography.Title level={4} className="text-center">
              <>HƯỚNG DẪN KIỂM TRA CHỨNG THƯ SỐ CẤP BÙ FASTCA</>
            </Typography.Title>

            <p>Quý khách cần thực hiện các bước sau để đảm bảo thiết bị USB hoạt động ổn định và kiểm tra được chứng thư
              thuộc chương trình cấp bù FastCA:</p>

            <div className="step">
              <b>Bước 1: Cập nhật Token phiên bản mới nhất</b>
              <ol>
                <li>Cài đặt/Mở <b>FastCA Token Manager</b></li>
                <li>Chọn mục “<b>Kiểm tra cập nhật</b>” để cập nhật token lên phiên bản mới nhất.</li>
              </ol>
            </div>

            <div className="step">
              <b>Bước 2: Cài đặt FastCA Plugin</b><br/>
              Tải và cài đặt plugin tại <a href="https://gen.fastca.vn/tao-lap-chung-thu/downloadPlugin" style={{textDecoration:"underline"}}><b>TẠI ĐÂY</b></a>. Sau khi cài đặt, mở trình duyệt và kiểm tra chứng thư
              chữ ký số thuộc chương trình cấp bù FastCA.
            </div>
            <br/>
            <div className="step">
              <b>Bước 3:</b> Nhập mã pin của USB token và ấn “<b>Tiếp tục</b>” để kiểm tra.
              <div className="text-center" style={{marginTop:'10px'}}>
                Nhập mã PIN token: <Password placeholder="Nhập mã PIN" style={{ width: "40%" }} onChange={(e) => setPin(e.target.value)}/>
              </div><br/>
              <div className="text-center">
                <Button type="primary" icon={<EditOutlined />} onClick={handleTiepTuc}>
                  Tiếp tục
                </Button>
              </div>
            </div>

            <div className="note">
              <b style={{color:"red",textDecoration:"underline"}}><i>Lưu ý:</i></b><br/>
              - Nếu chứng thư số của Quý khách <span style={{color:"red"}}><i>thuộc chương trình cấp bù</i></span>, màn hình sẽ tự động chuyển sang giao
              diện chương trình cấp bù của FastCA. Quý khách vui lòng khẩn trương thực hiện cấp bù theo hướng dẫn <span style={{color:"red"}}><i>trước
              ngày 22/12/2025</i></span> để tránh gián đoạn dịch vụ.<br/>
              - Nếu chứng thư số <span style={{color:"red"}}><i>không thuộc chương trình cấp bù</i></span>, Quý khách hàng vui lòng bỏ qua thông báo này và
              tiếp tục USB Token FastCA để ký số.
            </div>

          </div>);
    }else if (statusPage === 1){

    }else if (statusPage === 3){
      return (
          <div style={{ width: "100%" }}>

            <Typography.Title level={3} strong mark type="danger"
            className="text-center">
              <Space>
                <WarningOutlined />
                THÔNG BÁO
              </Space>
            </Typography.Title>
            <div>
              <div className="text-center" style={{width:"100%",fontSize:"17px"}}><b>CHỨNG THƯ SỐ CỦA QUÝ KHÁCH <i style={{color:"red",textDecoration:"underline"}}>KHÔNG THUỘC CHƯƠNG TRÌNH CẤP BÙ FASTCA 2025</i>,
                QUÝ KHÁCH VUI LÒNG BỎ QUA THÔNG BÁO VÀ TIẾP TỤC SỬ DỤNG DỊCH VỤ HIỆN TẠI.</b></div><br/>
              <div className="text-center" style={{width:"100%",fontSize:"17px"}}><b>MỌI THẮC MẮC HOẶC CẦN HỖ TRỢ, VUI LÒNG LIÊN HỆ TỔNG ĐÀI KỸ THUẬT 1900.2066 (NHÁNH 1) ĐỂ ĐƯỢC TƯ VẤN.</b></div><br/>
              <div className="text-center" style={{width:"100%",fontSize:"17px"}}><b>XIN CẢM ƠN QUÝ KHÁCH ĐÃ TIN TƯỞNG VÀ ĐỒNG HÀNH CÙNG FASTCA.</b></div><br/>

            </div>

          </div>
      );
    }
  }
  return (
      <>
        <Spin
            spinning={loadingPage}
            tip="Vui lòng đợi..."
            indicator={<LoadingOutlined style={{fontSize: 24}} spin/>}
        >
          <Flex
              justify="center"
              align="middle"
              style={{minHeight: "100vh", width: "1140px"}}
              className="lock-certificate-container container"
          >
            <Header/>
            {renderPage()}
            <Footer/>
          </Flex>
        </Spin>
      </>
  );
};

export default PublicCapBu;
